import styled from 'styled-components'
import { CLIENT_STYLINGS } from '../../../utils/constants'

export const SpinnerWrapper = styled.div`
  position: ${props => (props.$isAbsolute ? 'absolute' : '')};
  margin: ${props =>
    props.$autoMargin
      ? 'auto'
      : props.$noMargin
      ? '0'
      : props.$isBasic
      ? '100px auto'
      : '0px'};
  display: flex;
  justify-content: ${props => props.$justifyContent};
  flex-direction: column;
  align-items: center;
  width: ${props => (props.$isBasic ? '200px !important' : '100%')};
  height: ${props => (props.$isBasic ? '200px !important' : '100%')};
  padding: 0px 15px;
  left: ${props => (props.$isBasic ? 'calc(50% - 100px)' : 'unset')};
  top: ${props => (props.$isBasic ? 'calc(50% - 200px)' : 'unset')};
`

export const SpinnerLoader = styled.div`
  width: ${props => (props.$smallerSize ? '15px' : '40px')};
  height: ${props => (props.$smallerSize ? '15px' : '40px')};
  border: 5px solid #fff;
  border-bottom-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MAIN_COLOR};
  border-radius: 50%;
  box-sizing: border-box;
  margin-top: ${props => props.$marginTop};
`

export const MessageWrapper = styled.span`
  margin-top: 10px;
  text-align: center;
  font-weight: bold;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MAIN_COLOR};
  font-size: 14px;
  line-height: 1.4285em;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
`
